<template>
  <div class="base-search-bar p-0">
    <b-input-group>
      <!-- Search Input -->
      <b-form-input
        v-model.trim="searchQuery"
        :placeholder="placeholder"
        :size="size"
        :debounce="debounce"
        @input="handleInput"
        @keyup.enter="handleSearch"
      />
    </b-input-group>
  </div>
</template>

<script>
export default {
  name: 'BaseSearchBar',

  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Tìm kiếm...',
    },
    buttonText: {
      type: String,
      default: 'Tìm',
    },
    size: {
      type: String,
      default: 'sm',
    },
    debounce: {
      type: Number,
      default: 300,
    },
  },

  data() {
    return {
      searchQuery: this.value,
    };
  },

  watch: {
    value(newVal) {
      this.searchQuery = newVal;
    },
  },

  methods: {
    handleInput(value) {
      this.$emit('input', value);
    },

    handleSearch() {
      this.$emit('search', this.searchQuery);
    },

    clearSearch() {
      this.searchQuery = '';
      this.$emit('input', '');
      this.$emit('clear');
    },
  },
};
</script>
